import React from 'react';

const footerLinks = [
  ['Rooms', 'rooms'], ['Amenities', 'amenities'], ['Nearby', 'nearby'],
  ['Gallery', 'gallery'], ['Location', 'location'], ['Contact', 'contact'],
];

export default function Footer() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <style>{`
        .footer-link { font-family:'Jost',sans-serif; font-size:.58rem; letter-spacing:3px;
          text-transform:uppercase; color:rgba(242,232,217,0.4); cursor:pointer;
          transition:color .3s; background:none; border:none; }
        .footer-link:hover { color:#C9A84C; }
      `}</style>

      <footer style={{ background:'#06101E', padding:'3.5rem 3rem 2rem', borderTop:'1px solid rgba(201,168,76,0.15)' }}>
        <div style={{ maxWidth:'1100px', margin:'0 auto' }}>
          {/* Top row */}
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'1.5rem', marginBottom:'2.5rem' }}>
            {/* Lotus */}
            {/* <svg width="52" height="52" viewBox="0 0 120 120" fill="none">
              <circle cx="60" cy="60" r="55" stroke="#C9A84C" strokeWidth="1" fill="none" opacity=".35"/>
              {[...Array(14)].map((_,i)=>{
                const a=(i*25.7-90)*Math.PI/180;
                return <line key={i} x1={60+35*Math.cos(a)} y1={60+35*Math.sin(a)}
                  x2={60+49*Math.cos(a)} y2={60+49*Math.sin(a)} stroke="#C9A84C" strokeWidth="1.3" opacity=".55"/>;
              })}
              <path d="M24 76 Q60 92 96 76" fill="#1B2F6E" opacity=".9"/>
              {[0,60,120,180,240,300].map((deg,i)=>{
                const r=15, rad=deg*Math.PI/180;
                return <ellipse key={i} cx={60+r*Math.sin(rad)} cy={71-r*Math.cos(rad)*0.5}
                  rx="7.5" ry="13" transform={`rotate(${deg},${60+r*Math.sin(rad)},${71-r*Math.cos(rad)*0.5})`}
                  fill="#C9A84C" opacity=".48"/>;
              })}
              {[0,72,144,216,288].map((deg,i)=>{
                const r=9, rad=deg*Math.PI/180;
                return <ellipse key={i} cx={60+r*Math.sin(rad)} cy={68-r*Math.cos(rad)*0.6}
                  rx="5" ry="10" transform={`rotate(${deg},${60+r*Math.sin(rad)},${68-r*Math.cos(rad)*0.6})`}
                  fill="white" opacity=".88"/>;
              })}
              <ellipse cx="60" cy="66" rx="4" ry="9" fill="white"/>
            </svg> */}

            {/* Name */}
            <div style={{ textAlign:'center' }}>
              <div style={{ fontFamily:"'Cinzel',serif", fontSize:'1.3rem',
                letterSpacing:'3px', color:'#C9A84C', marginBottom:'.3rem' }}>
                Shree Maya Comfort Inn
              </div>
              <div style={{ fontFamily:"'Cormorant',serif", fontStyle:'italic',
                fontSize:'1rem', color:'rgba(242,232,217,0.4)' }}>
                Experience true hospitality
              </div>
            </div>

            {/* Divider */}
            <div style={{ display:'flex', alignItems:'center', gap:'.8rem' }}>
              <div style={{ width:'50px', height:'1px', background:'rgba(201,168,76,0.3)' }}/>
              <div style={{ width:'4px', height:'4px', background:'rgba(201,168,76,0.5)', transform:'rotate(45deg)' }}/>
              <div style={{ width:'50px', height:'1px', background:'rgba(201,168,76,0.3)' }}/>
            </div>

            {/* Links */}
            <div style={{ display:'flex', gap:'2rem', flexWrap:'wrap', justifyContent:'center' }}>
              {footerLinks.map(([label, id]) => (
                <button key={id} className="footer-link" onClick={() => go(id)}>{label}</button>
              ))}
            </div>

            {/* Phone */}
            <a href="tel:+919179954390" style={{
              fontFamily:"'Cinzel',serif", fontSize:'1rem', letterSpacing:'2px',
              color:'rgba(201,168,76,0.65)', textDecoration:'none', transition:'color .3s',
            }}>
              +91 91799 54390
            </a>
          </div>

          {/* Bottom */}
          <div style={{
            paddingTop:'1.5rem', borderTop:'1px solid rgba(242,232,217,0.07)',
            display:'flex', justifyContent:'center', alignItems:'center',
          }}>
            <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'.52rem',
              letterSpacing:'2px', textTransform:'uppercase',
              color:'rgba(242,232,217,0.18)', textAlign:'center' }}>
              © 2025 Shree Maya Comfort Inn · Ujjain, Madhya Pradesh · All Rights Reserved
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
